import { useQuery } from '@tanstack/react-query';

import { CardRegistrationParamType } from '../model/dto';
import { getBillingCards, getCarts } from './service';

export const getCartsQueryKey = ['carts'];

// refetchOnWindowFocus: 창 포커스 복귀 시 재호출 여부. 장바구니 페이지에서만 켜서(헤더 배지 등 공용 사용처는 기본 false)
// 띄워둔 채 딴 일 하다 돌아와도 매물 최신값(입주가능일·최소계약기간 등)이 반영되도록 한다.
export const useGetCarts = ({ refetchOnWindowFocus = false }: { refetchOnWindowFocus?: boolean } = {}) => {
  return useQuery({
    queryKey: getCartsQueryKey,
    queryFn: () => getCarts(),
    refetchOnWindowFocus,
  });
};

export const useGetBillingCards = ({ userId, orderType }: CardRegistrationParamType) => {
  return useQuery({
    queryKey: ['billing-cards', userId, orderType],
    queryFn: () => getBillingCards({ userId, orderType }),
    enabled: !!userId,
  });
};
